<template>
  <div id="app">
    <div class="head">
      <div class="head-left" @click="togo">
        <img src="../../assets/img/head-back.png" alt="" srcset="">
      </div>
      <div class="head-center">
        <img src="../../assets/img/logo.png" alt />
        <span>好运吧</span>
      </div>
      <div class="head-right"></div>
  </div>
  </div>
</template>
<script>

export default {
  // metaInfo: {
  //   title: "好运吧"
  // },
  name: "app",
  data() {
    return {
      msg: "注册协议Index",
       vuetiltle: this.title
    };
  },
  props: {
    title: String,
  },
  methods: {
   togo(){
     history.go(-1)
   }
  },

  components: {}
};
</script>
<style  scoped>

/****同步信息 */
#app {
  width: 750px;
  background: #ffffff;
}
.head {
  width: 750px;
  height: 110px;
  display: flex;
  margin: 0;
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  background: #ffffff;
  border: 1px solid #EEEEEE;
}
.head-left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.head-left img{
  width: 44px;
  height: 44px;
}

.btn-text {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 27px;
  margin-left: 31px;
}

.menu-list {
  width: 243px;
  height: 473px;
  background: #000000;
  opacity: 0.7;
  position: absolute;
}

.head-right {
  flex: 1;
}
.head-center {
  width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.head-center img {
  width: 60px;
  height: 60px;
}
.head-center span {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 27px;
  display: inline-block;
  margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/common/head-back-close.vue